import React from "react";
import { BsPerson } from "react-icons/bs";

function DetailTile({ icon, heading, subHeading, tags, tagsArray, iconTooltipId, iconTooltipContent, iconTooltipPosition }) {

  console.log(subHeading, 'TESTING');

  return (
    <div className="flex gap-4 border-dotted pb-8 border-b border-white border-opacity-10] h-full">
      <div className="rounded-full h-[44px] w-[44px] flex items-center justify-center bg-primary bg-opacity-10" data-tooltip-id={iconTooltipId ?? ""} data-tooltip-content={iconTooltipContent ?? ""} data-tooltip-place={iconTooltipPosition ?? "bottom"}>
        <BsPerson className={'text-orange-400'} />
      </div>
      <div className="w-full">
        <p className="font-semibold text-[15px] left-4 text-white mb-2">
          {heading}
        </p>
        <div className="text-[15px] left-4 text-[#c2c2c2] w-full">
          {tags ? (
            <div className="flex items-center max-w-full overflow-auto">
              {tagsArray?.map((tag, index) => {
                return (
                  <span
                    key={index}
                    className="bg-[#8796B1] bg-opacity-10 text-[#555] text-[12px] pr-4 rounded-full mr-2 flex items-center gap-2"
                  >
                    <div
                      style={{ background: `${tag.bg}` }}
                      className="h-6 w-6 rounded-full flex items-center justify-center uppercase text-white font-bold text-[12px]"
                    >
                      {tag.initials}
                    </div>
                    {tag.name}
                  </span>
                );
              })}
            </div>
          ) : (
            <>{subHeading ?? "NA"}</>
          )}
        </div>
      </div>
    </div>
  );
}

export default DetailTile;
